// extracted by mini-css-extract-plugin
export default {"surface":"OP1WebWindowManagerSurface_surface__Y3RF5"};